"use strict";

let instance = null;
const GamedockSDK = require("gamedock-web-tracker/dist/umd/gamedock-sdk.min");
import store from "@/store";
import { isProduction } from "../utils";

/**
 * Gamedock Tracker
 */
export class Gamedock {
  /**
   * Constructor of EventBus.
   * @return {*}
   */
  constructor() {
    // Make this a singleton.
    if (instance) return instance;
    else instance = this;

    const OrganizationID = isProduction ? "plinga" : "plinga-test";

    this.SDK = GamedockSDK.initialize(OrganizationID, store.getters.getDomain);
  }

  gamePlay(pageId, pageType, isAuthorized) {
    if (!this.SDK) return;
    this.SDK.tracking.trackEvent("gameplay", {
      pageId: pageId.toString(),
      pageType: pageType.toString(),
      isAuthorized: !!isAuthorized
    });
  }

  pageView(pageId, pageType, isAuthorized) {
    if (!this.SDK) return;
    this.SDK.tracking.trackEvent("pageview", {
      pageId: pageId.toString(),
      pageType: pageType.toString(),
      isAuthorized: !!isAuthorized
    });
  }

  registration(pageId) {
    if (!this.SDK) return;
    this.SDK.tracking.trackEvent("registration", {
      pageId: pageId.toString()
    });
  }

  payment(data) {
    if (!this.SDK) return;
    this.SDK.tracking.trackEvent("payment", {
      pageId: data.pageId,
      isAuthorized: !!data.isAuthorized,
      globalUserId: data.globalUserId,
      transactionId: data.transactionId,
      packageName: data.packageName,
      revenue: data.revenue,
      currency: data.currency,
      paymentStatus: data.paymentStatus,
      paymentMethod: data.paymentMethod,
      paymentProvider: data.paymentProvider
    });
  }
}
